function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Events } from '../utils/events';
import { isNone } from '@ember/utils';

// https://github.com/jquery/jquery/blob/543d3d24eaefe09c4012171f30267783d51602dc/src/offset.js#L75
function elementOffset(element) {
  // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
  // Support: IE <=11 only
  // Running getBoundingClientRect on a
  // disconnected node in IE throws an error
  if (!element.getClientRects().length) {
    return {
      top: 0,
      left: 0
    };
  }

  // Get document-relative position by adding viewport scroll to viewport-relative gBCR
  let rect = element.getBoundingClientRect();
  let win = element.ownerDocument.defaultView;
  return {
    top: rect.top + (win?.pageYOffset ?? 0),
    left: rect.left + (win?.pageXOffset ?? 0)
  };
}
const DEFAULT_OPTIONS = {
  classes: ['fly-sortable-list-placeholder'],
  offsets: {
    width: 0,
    height: 0,
    top: 0,
    left: 0
  },
  changeOffsetSignDependingOnPosition: false
};
export default class SortableListPlaceholder {
  get options() {
    let options = this.modifierInstance.named.pluginOptions?.sortableListPlaceholder ?? {
      classes: []
    };
    let classes = [...DEFAULT_OPTIONS.classes, ...(options.classes || [])];
    return Object.assign({}, DEFAULT_OPTIONS, options, {
      classes
    });
  }
  constructor(modifierInstance) {
    _defineProperty(this, "element", void 0);
    _defineProperty(this, "modifierInstance", void 0);
    _defineProperty(this, "dropIndicator", null);
    this.element = modifierInstance.droppableElement;
    this.modifierInstance = modifierInstance;
    this.onDragEnter = this.onDragEnter.bind(this);
    this.onDragSort = this.onDragSort.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
  }
  attach() {
    this.element.addEventListener(Events.DragEnter, this.onDragEnter);
    this.element.addEventListener(Events.DragSort, this.onDragSort);
    this.element.addEventListener(Events.DragLeave, this.onDragLeave);
    this.modifierInstance.flyDragDropManager.on(Events.DragEnd, this.onDragEnd);
  }
  detach() {
    this.element.removeEventListener(Events.DragEnter, this.onDragEnter);
    this.element.removeEventListener(Events.DragSort, this.onDragSort);
    this.element.removeEventListener(Events.DragLeave, this.onDragLeave);
    this.modifierInstance.flyDragDropManager.off(Events.DragEnd, this.onDragEnd);
    this.removeDropIndicator();
  }
  onDragEnter() {
    this.appendDropIndicator();
  }
  onDragSort(event) {
    this.showDropIndicator({
      currentIndex: event.detail.context.currentIndex,
      targetIndex: event.detail.context.targetIndex,
      targetElement: event.detail.context.targetElement,
      position: event.detail.context.position
    });
  }
  onDragLeave() {
    this.removeDropIndicator();
  }
  onDragEnd() {
    this.removeDropIndicator();
  }
  appendDropIndicator() {
    let {
      dropIndicator
    } = this;
    if (!dropIndicator) {
      dropIndicator = document.createElement('div');
      dropIndicator.classList.add(...this.options.classes);
      dropIndicator.style.opacity = '0';
      dropIndicator.style.width = '0';
      dropIndicator.style.height = '0';
      document.body.appendChild(dropIndicator);
    }
    this.dropIndicator = dropIndicator;
  }
  removeDropIndicator() {
    if (!this.dropIndicator) {
      return;
    }
    this.dropIndicator.remove();
    this.dropIndicator = null;
  }
  hideDropIndicator() {
    if (!this.dropIndicator) {
      return;
    }
    this.dropIndicator.style.opacity = '0';
  }
  showDropIndicator({
    currentIndex,
    targetIndex,
    targetElement,
    position
  }) {
    let coordinates = targetElement.getBoundingClientRect();
    let offset = elementOffset(targetElement);
    if (isNone(position) && isNone(currentIndex) && targetIndex === 0) {
      return this.updateDropIndicatorStyles(coordinates.width, coordinates.height, offset.top, offset.left, position);
    }
    if (currentIndex === targetIndex) {
      return this.hideDropIndicator();
    }
    let targetTop = offset.top;
    if (position === 'bottom') {
      targetTop = targetTop + coordinates.height;
    }
    this.updateDropIndicatorStyles(coordinates.width, 4, targetTop, offset.left, position);
  }
  updateDropIndicatorStyles(width, height, top, left, position) {
    let dropIndicator = this.dropIndicator;
    if (!dropIndicator) {
      return;
    }
    let {
      changeOffsetSignDependingOnPosition,
      offsets
    } = this.options;
    let {
      top: offsetTop
    } = offsets;

    // Sometimes we need to apply negative offsets for the top edge, and
    // positive offsets for the bottom. This may be needed in scenarios where
    // draggables are separated by empty spaces that are not part of themselves
    // (i.e. not their padding). Otherwise the placeholder will render right at
    // the edges of the draggables:
    //  -----------
    // | draggable |
    //  -----------   <-- placeholder here
    //
    //
    //
    //  -----------   <-- or placeholder here
    // | draggable |
    //  -----------
    //
    //  But we want the placeholder to always be between them:
    //  -----------
    // | draggable |
    //  -----------
    //
    //  ===========   <-- placeholder here
    //
    //  -----------
    // | draggable |
    //  -----------
    //
    //  This works well when draggables are equidistant. If draggables are
    //  separated by different sizes of gaps, this won't work (and we don't have
    //  a solution for it yet).
    if (changeOffsetSignDependingOnPosition && position === 'top') {
      offsetTop = -offsetTop;
    }
    dropIndicator.style.width = `${width + offsets.width}px`;
    dropIndicator.style.height = `${height + offsets.height}px`;
    dropIndicator.style.top = `${top + offsetTop}px`;
    dropIndicator.style.left = `${left + offsets.left}px`;
    dropIndicator.style.opacity = '1';
  }
}